import { inject } from '@angular/core';
import { Route } from '@angular/router';
import {
  AppSurfaceStore,
  MANAGE_PATHS,
  MANAGE_ROUTE_PREFIX,
} from '@marineform/manage-data-access';
import { NotFoundPageComponent } from './pages/errors/not-found';
import { manageAuthGuard } from './guards/manage-auth.guard';
import { marketEnabledGuard } from './guards/market-enabled.guard';
import { loginPageResolver } from './resolvers/login-page.resolver';

export const appRoutes: Route[] = [
  {
    path: MANAGE_ROUTE_PREFIX,
    canActivate: [manageAuthGuard],
    loadChildren: () => import('./routes/manage/manage.routes').then((m) => m.manageRoutes),
  },
  {
    path: MANAGE_PATHS.NOT_FOUND,
    component: NotFoundPageComponent,
  },
  {
    path: MANAGE_PATHS.LOGIN,
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.ManageLoginPage),
    resolve: { loggedOut: loginPageResolver },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => inject(AppSurfaceStore).homePath(),
  },
  {
    path: '',
    canMatch: [marketEnabledGuard],
    loadChildren: () => import('./routes/market/market.routes').then((m) => m.marketRoutes),
  },
  {
    path: '**',
    redirectTo: MANAGE_PATHS.NOT_FOUND,
    pathMatch: 'full',
  },
];
